import PropTypes from 'prop-types'
import React from 'react'
import styles from 'layouts/WideLayout/WideLayout.module.scss'
import { CloseButton } from 'layouts/WideLayout/subcomponents'
import Header from 'components/Header'
import { Grid } from 'gu-ui-kit'
import clsx from 'clsx'
import Footer from 'components/Footer'
import findMatchedRoutes, { getLastMatchedRoute } from 'utils/findMatchedRoutes'
import LayoutSuspense from 'layouts/LayoutSuspense'
import { WideLayoutProvider, useWideLayoutContext } from 'layouts/WideLayout/context'

const WideLayoutContent = ({ children = null }) => {
  const { invokeClose } = useWideLayoutContext()
  const matchedRoutes = findMatchedRoutes()

  return (
    <Grid
      component={'section'}
      className={styles['layout']}
      direction={'column'}
      wrap={false}
    >
      <Grid
        direction={'row'}
        fluid
        wrap={false}
        className={styles['layout__header-container']}
        gap={8}
      >
        <Grid className={styles['layout__header']}>
          <Header noToggler={true} />
        </Grid>

        <CloseButton onClose={invokeClose} />
      </Grid>

      <Grid
        className={styles['layout__content']}
        wrap={false}
        direction={'column'}
      >
        <Grid
          className={clsx({
            'layout-tile': !getLastMatchedRoute(matchedRoutes)?.restyled,
          })}
          alignSelf={'start'}
          wrap={false}
          direction={'column'}
        >
          <LayoutSuspense>{children}</LayoutSuspense>
        </Grid>
      </Grid>
      <Footer wide />
    </Grid>
  )
}

WideLayoutContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
}

const WideLayout = ({ children = null, onClose }) => (
  <WideLayoutProvider defaultOnClose={onClose}>
    <WideLayoutContent>{children}</WideLayoutContent>
  </WideLayoutProvider>
)

WideLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  onClose: PropTypes.func,
  contentClassName: PropTypes.string,
}

export default WideLayout
